import React from "react";

import {priceFormat} from "@pg-mono/string-utils";

import {getOfferTypePluralize} from "../../helpers/OfferType";
import {offerDetailDescriptionSubheading} from "./OfferDetailDescription";
import {IRoomRange} from "./OfferDetailGeneratedDescription";

interface IOfferDetailGeneratedDescriptionRoomRanges {
    header: string;
    rooms_ranges: IRoomRange[];
    type: number;
}

export const OfferDetailGeneratedDescriptionRoomRanges = (props: IOfferDetailGeneratedDescriptionRoomRanges) => {
    if (!props.rooms_ranges?.length) {
        return null;
    }

    const renderRoomRanges = () => {
        return props.rooms_ranges.map((room, index) => {
            const isRoomAreaMinSameAsMax = room.area.min === room.area.max;
            const roomAreaMin = room.area.min && `${isRoomAreaMinSameAsMax ? "" : "od"} ${room.area.min}`;
            const roomAreaMax = room.area.max && !isRoomAreaMinSameAsMax && ` do ${room.area.max}`;
            const roomPrice = room.price.min && `w cenie od ${priceFormat(room.price.min)}`;

            return (
                <li key={index}>
                    {`${index}-pokojowe o powierzchni ${roomAreaMin} ${roomAreaMax} `}m<sup>2</sup>
                    {` ${roomPrice} (${room.count} ${getOfferTypePluralize(room.count, props.type)}) `}
                </li>
            );
        });
    };

    return (
        <>
            <p css={offerDetailDescriptionSubheading}>{props.header}</p>

            <ul>{renderRoomRanges()}</ul>
        </>
    );
};
import React from "react";

import {priceFormat} from "@pg-mono/string-utils";

import {getOfferTypePluralize} from "../../helpers/OfferType";
import {offerDetailDescriptionSubheading} from "./OfferDetailDescription";
import {IRoomRange} from "./OfferDetailGeneratedDescription";

interface IOfferDetailGeneratedDescriptionRoomRanges {
    header: string;
    rooms_ranges: IRoomRange[];
    type: number;
}

export const OfferDetailGeneratedDescriptionRoomRanges = (props: IOfferDetailGeneratedDescriptionRoomRanges) => {
    if (!props.rooms_ranges?.length) {
        return null;
    }

    const renderRoomRanges = () => {
        return props.rooms_ranges.map((room, index) => {
            const isRoomAreaMinSameAsMax = room.area.min === room.area.max;
            const roomAreaMin = room.area.min && `${isRoomAreaMinSameAsMax ? "" : "od"} ${room.area.min}`;
            const roomAreaMax = room.area.max && !isRoomAreaMinSameAsMax && ` do ${room.area.max}`;
            const roomPrice = room.price.min && `w cenie od ${priceFormat(room.price.min)}`;

            return (
                <li key={index}>
                    {`${index}-pokojowe o powierzchni ${roomAreaMin} ${roomAreaMax} `}m<sup>2</sup>
                    {` ${roomPrice} (${room.count} ${getOfferTypePluralize(room.count, props.type)}) `}
                </li>
            );
        });
    };

    return (
        <>
            <p css={offerDetailDescriptionSubheading}>{props.header}</p>

            <ul>{renderRoomRanges()}</ul>
        </>
    );
};
